// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import * as tslib_1 from "tslib";
// THIS FILE WAS AUTOGENERATED
import { EventData } from './EventData';
/**
 * An instance of PageView represents a generic action on a page like a button click. It is also the base type for PageView.
 */
var PageViewData = /** @class */function (_super) {
  tslib_1.__extends(PageViewData, _super);
  function PageViewData() {
    var _this = _super.call(this) || this;
    _this.ver = 2;
    _this.properties = {};
    _this.measurements = {};
    return _this;
  }
  return PageViewData;
}(EventData);
export { PageViewData };
